import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeVarys2';
const args = {};

export class ModeVarys2 extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
